import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NgFor, NgIf } from '@angular/common';
import { PanelModule } from 'primeng/panel';
import { ButtonModule } from 'primeng/button';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { AvatarModule } from 'primeng/avatar';
import { ChipModule } from 'primeng/chip';
import { DropdownModule } from 'primeng/dropdown';
import { FormsModule } from '@angular/forms';
import { DividerModule } from 'primeng/divider';
import { MessageItemComponent } from "../message-item/message-item.component";
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService, MenuItem, Message, MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { MessagesModule } from 'primeng/messages';
import { MessageDetails } from '../../Models/messageDetails';
import { MessageBubble } from '../../Models/messageBubble';
import { AccordionModule } from 'primeng/accordion';
import { InputTextModule } from 'primeng/inputtext';
import { DialogModule  } from 'primeng/dialog';
import { MenuModule } from 'primeng/menu';

import commandsList from '../../commands.json';
import { PlockapiService } from '../../../services/plockapi.service';
import { StorageService } from '../../../services/storage.service';

@Component({
    selector: 'app-terminal',
    standalone: true,
    templateUrl: './terminal.component.html',
    styleUrl: './terminal.component.css',
    imports: [
      NgIf,
      NgFor,
      PanelModule,
      ScrollPanelModule,
      AvatarModule,
      ChipModule,
      DropdownModule,
      FormsModule,
      DividerModule,
      ButtonModule,
      ConfirmDialogModule,
      AccordionModule,
      InputTextModule,
      MessagesModule,
      ToastModule,
      DialogModule,
      MessageItemComponent,
      MenuModule
    ],
      providers: [ConfirmationService, MessageService]
})
export class TerminalComponent implements OnInit, AfterViewInit {
  commands: any[] = [];
  selectedCmd: any;
  messagesList: any[] = [];
  sentMessage: string = "";
  loadingMessage!: Message[];
  lastHeight: number = 0;
  customcmd: any;
  awaitingResponse: boolean = false;
  sendingMessage: boolean = false;
  attempts: number = 0;
  visible: boolean = false;
  tokenDetectado: boolean = false;
  bleToken: string | undefined;
  modalTitle: string = "";
  bleItems: MenuItem[] = [];
  wifiItems: MenuItem[] = [];
  frequentButtons: MenuItem[] = [];
  @ViewChild("terminal", { static: true }) _element: any;
  @Input() chatHistory: MessageDetails[] = [];
  @Input() selectedDevice: any;
  @Output() refreshMessages = new EventEmitter();
  private intervalId: any;

  constructor(
    private confirmationService: ConfirmationService,
    private _service: PlockapiService,
    private _storage: StorageService,
    private messageService: MessageService
  ) {
    this.commands = commandsList.v2;

    this.bleItems = [{
      label: 'Obtener token Bluetooth',
      icon: 'pi pi-plus',
      command: () => {
        this.getBluetoothToken();
      }
    },
    {
      label: 'Renovar token Bluetooth',
      icon: 'pi pi-refresh',
      command: () => {
        this.renewBluetoothToken();
      }
    }]

    this.wifiItems = [{
      label: 'Obtener clave WiFi',
      icon: 'pi pi-plus',
      command: () => {
        this.getWifiToken();
      }
    },
    {
      label: 'Renovar clave WiFi',
      icon: 'pi pi-refresh',
      command: () => {
        this.renewWifiToken();
      }
    }]
  }

  ngAfterViewInit(): void {
    this._element.contentViewChild.nativeElement.scrollTop = this._element?.contentViewChild.nativeElement.scrollHeight;
  }

  ngOnInit(): void {
    this.loadingMessage = [{ severity: 'info', detail: 'Aguardando respuesta...' }];
    this.loadChatHistory();

    this.intervalId = setInterval(() => {
      this.getAllMessages();
    }, 5000);
  }

  showConfirm() {
    if (!this.visible) {
      this.messageService.add({
        key: 'confirm',
        sticky: true,
        severity: 'info',
        summary: 'El equipo no puede recibir el comando. Intente más tarde',
        detail: 'Debido a la falta de reporte/cobertura, no hay una dirección válida a donde enviar el comando.'
       });
      this.visible = true;
    }
  }

  loadChatHistory() {
    if (this.chatHistory && this.chatHistory.length > 0) {
      this.messagesList = [];
      this.chatHistory.reverse().forEach(m => {
        this.messagesList.push(new MessageBubble({ msg: m.CmdEnviado, sender: true, author: m.Usuario, date: m.FechaEnviado }));
        if (m.CmdRecibido)
          this.messagesList.push(new MessageBubble({ msg: m.CmdRecibido, sender: false, author: this.selectedDevice.name, date: m.FechaRecibido }));
      });
    }
    if (this._element.contentViewChild)
      this._element.contentViewChild.nativeElement.scrollTop = this._element?.contentViewChild.nativeElement.scrollHeight;
  }

  confirmCommand(event: string){
    let cmd = this.commands.find(x => x.name === event);
    this.sendCommand(cmd);
  }

  sendCommand(cmd: any) {
    if (cmd.name === 'Apertura') {
      this.confirmationService.confirm({
        message: `Desea proceder con el envío del comando: ${cmd.name}?`,
        header: 'Confirmación',
        icon: 'pi pi-exclamation-triangle',
        acceptIcon: "none",
        rejectIcon: "none",
        acceptLabel: "Enviar",
        acceptButtonStyleClass: "p-button-danger",
        rejectButtonStyleClass: "p-button-text",
        accept: () => {
          this.messageCallBack(cmd);
        }
      });
    }
    else {
      this.messageCallBack(cmd);
    }
  }

  getWifiToken() {
    let wifiMsgs = this.chatHistory.filter(x => x.CmdRecibido?.includes('RAPX'));
    if (wifiMsgs.length > 0) {
      this.bleToken = wifiMsgs[wifiMsgs.length - 1].CmdRecibido?.split(',')[1];
      this.tokenDetectado = true;
      this.modalTitle = "Clave WIFI";
    }
    else {
      this.messageService.add({
        key: 'confirm',
        sticky: true,
        severity: 'info',
        summary: 'No hay una clave para el WiFi',
        detail: 'No se ha detectado una clave wifi para el equipo recientemente.'
       });
    }
  }

  getBluetoothToken() {
    let bluetoothMsgs = this.chatHistory.filter(x => x.CmdRecibido?.includes('RCXBTH0'));
    if (bluetoothMsgs.length > 0) {
      this.bleToken = bluetoothMsgs[bluetoothMsgs.length - 1].CmdRecibido?.split(',')[2];
      this.tokenDetectado = true;
      this.modalTitle = "Token Bluetooth";
    }
    else {
      this.messageService.add({
        key: 'confirm',
        sticky: true,
        severity: 'warn',
        summary: 'No hay un token para el bluetooth',
        detail: 'No se ha detectado un token para el equipo recientemente.'
       });
    }
  }

  renewBluetoothToken() {
    let newCode = Math.floor(100000 + Math.random() * 900000);
    const renewCmd = `>SCXBTH0,${this.selectedDevice.name},${newCode},60<`;
    this.sendCommand(renewCmd);
  }

  renewWifiToken() {
    let newCode = Math.floor(10000000 + Math.random() * 900000);
    const renewCmd = `>SAPX${this.selectedDevice.name},${newCode},192.168.1.88,255.255.255.0,192.168.1.1<`;
    this.sendCommand(renewCmd);
  }

  messageCallBack(cmd: any) {
    let user = this._storage.getStoredUser();
    let command = cmd.name ? { name: cmd.name, code: cmd.code } : { name: cmd, code: cmd };
    let message: any =  { msg: command.name, sender: true, author: user.NombreReal, date: new Date()};
    this.messagesList.push(message);
    this.sentMessage = command.code.substring(0, command.code.length - 1);
    this.sendingMessage = true;
    this.awaitingResponse = true;
    this._service.sendMessage(`${this.selectedDevice.name},${command.code},${user.Id}`).subscribe({
      next: res => {
        this._element.contentViewChild.nativeElement.scrollTop = this._element?.contentViewChild.nativeElement.scrollHeight;
        this.sendingMessage = false;
        this.getAllMessages();
      },
      error: err => {
        this.sendingMessage = false;
      }
    });
  }

  getAllMessages(): void {
    if (this.sentMessage.length > 0 && !this.sendingMessage) {
      setTimeout(() => {
        this._service.getChatHistory(this.selectedDevice.code).subscribe({
          next: re => {
            this.chatHistory = re;
            this.attempts++;
            if (this.chatHistory[0].CmdEnviado?.includes(this.sentMessage) && this.attempts < 2) {
              this.resetValues();
            }
            else {
              this.showConfirm();
              this.resetValues();
            }
          }
        });
      }, 3000);
    }
  }

  resetValues(): void {
    this.loadChatHistory();
    this.sentMessage = "";
    this.awaitingResponse = false;
    this.attempts = 0;
  }
}
